function CloseIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="w-6 h-6"
    >
      {/* Calendar body */}
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
      {/* Calendar top hooks */}
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      {/* Horizontal line below hooks */}
      <line x1="3" y1="10" x2="21" y2="10" />
      {/* Checkmark */}
      <path d="M9 16l2 2 4-4" />
    </svg>
  )
}

export default CloseIcon
